import palette from '../theme/palette';

const styleOverrides = {
  root: {
    padding: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
    marginBottom: '-13px',
    paddingBottom: '13px',
    minWidth: 0,
    '&.MuiButtonBase-root.MuiTab-root': {
      minHeight: '0',
    },
    '&:first-of-type': {
      marginLeft: '0',
    },
    '&.Mui-selected, :hover': {
      color: palette.primary.main,
    },
    '& .MuiTypography-root': {
      lineHeight: 1.25,
    },
  },
  textColorInherit: {
    opacity: 1,
    '&:hover': {},
    '&$selected, &$selected:hover': {
      opacity: 1,
    },
    '&$disabled': {},
  },
};

export default styleOverrides;
